/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartAnimator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartAnimator";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {PolyBetLine} from "@nolimitcity/slot-game/bin/game/betline/line/PolyBetLine";
import {NudgeSpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelPartAnimator";
import {NearWinReelDivider} from "@nolimitcity/slot-game/bin/game/reeldivider/NearWinReelDivider";
import {BetLineWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {GameModeTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";
import {GameRoundConfig} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {HarlequinBackground} from "./background/HarlequinBackground";
import {HarlequinBetlineView} from "./betlines/HarlequinBetlineView";
import {HarlequinRespinOutroView} from "./freespin/transitions/HarelequinRespinOutroView";
import {HarlequinFreespinOutroView} from "./freespin/transitions/HarlequinFreespinOutroView";
import {HarlequinRespinOutroTransition} from "./freespin/transitions/HarlequinRespinOutroTransition";
import {HarlequinTransitionController} from "./freespin/transitions/HarlequinTransitionController";
import {HarlequinTransitionViewWrapper} from "./freespin/transitions/HarlequinTransitionViewWrapper";
import {RespinTransitionController} from "./gamemode/RespinTransitionController";
import {HarlequinBetLineWin} from "./gameround/betline/HarlequinBetlineWin";
import {BigWinStart} from "./gameround/bigWin/BigWinStart";
import {BigWinStep} from "./gameround/bigWin/BigWinStep";
import {HarlequinAddFreespin} from "./gameround/freespin/HarlequinAddFreespin";
import {HarlequinAddFreespinView} from "./gameround/freespin/HarlequinAddFreespinView";
import {HarlequinCollectManager} from "./gameround/freespin/HarlequinCollectManager";
import {HarlequinScatterCollector} from "./gameround/freespin/HarlequinScatterCollector";
import {HarlequinScatterCollectorView} from "./gameround/freespin/HarlequinScatterCollectorView";
import {WildDrop} from "./gameround/freespin/WildDrop";
import {WildDropFirstSpin} from "./gameround/freespin/WildDropFirstSpin";
import {HarlequinBetLineInit} from "./gameround/HarlequinBetLineInit";
import {HarlequinBetlineToggle} from "./gameround/HarlequinBetlineToggle";
import {HarlequinWildNudge} from "./gameround/HarlequinWildNudge";
import {InitialWin} from "./gameround/InitialWin";
import {MultiplierBetWins} from "./gameround/MultiplierBetWins";
import {HarlequinNearWinReelFour} from "./gameround/nearwin/HarlequinGameRoundReelFour";
import {HarlequinNearWin} from "./gameround/nearwin/HarlequinNearWin";
import {NearWinView} from "./gameround/nearwin/NearWinView";
import {NormalWin} from "./gameround/NormalWin";
import {BonusIntroView} from "./gameround/presentations/BonusIntroView";
import {HarlequinSignHandler} from "./gameround/presentations/HarlequinSignHandler";
import {HarlequinSignView} from "./gameround/presentations/HarlequinSignView";
import {HarlequinWalkerManager} from "./gameround/presentations/HarlequinWalkerManager";
import {HarlequinZeroBet} from "./gameround/presentations/HarlequinZeroBet";
import {MultiplierBetWinView} from "./gameround/presentations/MultiplierBetWinView";
import {ReelStart} from "./gameround/ReelStart";
import {ReelStop} from "./gameround/ReelStop";
import {SpinStart} from "./gameround/SpinStart";
import {SpinStop} from "./gameround/SpinStop";
import {WinEnd} from "./gameround/WinEnd";
import {HarlequinFontConfig} from "./HarlequinFontConfig";
import {HarlequinGameAssets} from "./HarlequinGameAssets";
import {HarlequinGameConfig} from "./HarlequinGameConfig";
import {HarlequinSoundConfig} from "./HarlequinSoundConfig";
import {HarlequinReelAreaView} from "./reel/HarlequinReelAreaView";
import {HarlequinReelView} from "./reel/HarlequinReelView";
import {HarlequinParsedGameData} from "./server/data/HarlequinParsedGameData";
import {HarlequinParsedInitData} from "./server/data/HarlequinParsedInitData";
import {HarlequinServerDataParser} from "./server/HarlequinServerDataParser";
import {HarlequinSpinReelController} from "./spinreel/HarlequinSpinReelController";
import {HarlequinReelSymbol} from "./symbols/HarlequinReelSymbol";
import {HarlequinReelSymbolStateCreator} from "./symbols/HarlequinReelSymbolStateCreator";
import {CountUpView} from "./views/parts/CountUpView";
import {WinTextView} from "./views/parts/WinTextView";
import {HarlequinTextBetLineNumber} from "./views/textbetline/HarlequinTextBetLineNumber";
import {HarlequinWalkerView} from "./views/walker/HarlequinWalkerView";
import {FeaturePrice} from "./server/FeaturePrice";


export class HarlequinGameModuleConfig implements IGameModuleConfig {

    public static instance:HarlequinGameModuleConfig = new HarlequinGameModuleConfig();
    private static gameTweakerTest:GameTweakerTest;
    public static background:StillImageBackground;
    public static featurePrice:FeaturePrice;

    GAME_CONFIG:IGameConfig = HarlequinGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = HarlequinSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = HarlequinFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = HarlequinGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new HarlequinServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => new HarlequinParsedInitData(data, <HarlequinServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => new HarlequinParsedGameData(data, <HarlequinServerDataParser>dataParser);

    REEL_AREA_VIEW:() => ReelAreaView = () => new HarlequinReelAreaView();

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => new HarlequinSpinReelController(reelId);

    REELS:() => Reels = () => new TimelineReelsController();

    REEL_PART_ANIMATOR:(reelId:number) => ReelPartAnimator = (reelId:number) => new NudgeSpinReelPartAnimator(reelId);

    REEL_VIEW:(reelId:number) => PIXI.Container = reelId => new HarlequinReelView();

    REEL_PART_CREATOR:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):HarlequinReelSymbol => {
            return new HarlequinReelSymbol(symName, reelId, state);
        });

    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => new HarlequinReelSymbolStateCreator();

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => new BetLineWinIndividualWPController({
        symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
            return 0;
        }
    });

    GAME_MODE_TRANSITIONS:(() => GameModeTransitionController)[] = [
        () => new HarlequinTransitionController(GameMode.NORMAL, GameMode.FREESPIN, new HarlequinTransitionViewWrapper()),
        () => new HarlequinTransitionController("WILD_RESPIN", GameMode.FREESPIN, new HarlequinTransitionViewWrapper()),
        () => new HarlequinTransitionController(GameMode.FREESPIN, GameMode.NORMAL, new HarlequinFreespinOutroView(StageManager.getLayer(this.GAME_CONFIG.LAYERS.INTRO.name)), true),
        () => new HarlequinTransitionController("WILD_RESPIN_FS", GameMode.NORMAL, new HarlequinFreespinOutroView(StageManager.getLayer(this.GAME_CONFIG.LAYERS.INTRO.name)), true),
        () => new RespinTransitionController(GameMode.NORMAL, "WILD_RESPIN"),
        () => new HarlequinRespinOutroTransition("WILD_RESPIN", GameMode.NORMAL, new HarlequinRespinOutroView(this.GAME_CONFIG.LAYERS.RESPIN_OUTRO.name)),
        () => new RespinTransitionController(GameMode.FREESPIN, "WILD_RESPIN_FS"),
        () => new GameModeTransitionController("WILD_RESPIN_FS", GameMode.NORMAL), // TODO, should this  be here? There already is one for this transition.
        () => new HarlequinRespinOutroTransition("WILD_RESPIN_FS", GameMode.FREESPIN, new HarlequinRespinOutroView(this.GAME_CONFIG.LAYERS.RESPIN_OUTRO.name))
    ];

    GAME_ROUND_CONFIG:() => GameRoundConfig = () => {
        //debugger;
        return {
            NORMAL : {
                idle : [
                    new HarlequinBetLineInit(true),
                    new HarlequinBetlineToggle()
                ],
                idleLoop : [],
                starting : [
                    new MultiplierBetWins(true),
                    //new HarlequinInFsCollector(0, true), // TODO: check usage
                    new HarlequinScatterCollector(0, true), // TODO: check usage
                    new HarlequinCollectManager(true),
                    new HarlequinWalkerManager(true, true),
                    new SpinStart(),
                    new ReelStart(2, 0.05),
                    new ReelStart(1, 0),
                    new ReelStart(3, 0.05),
                    new ReelStart(0, 0),
                    new ReelStart(4, 0.05),
                ],
                stoppable : [

                    //new HarlequinNearWin(0, 2.5, 1),
                    new ReelStop(0),

                    new HarlequinNearWin(1, 1.5, 1),
                    new ReelStop(1),

                    new HarlequinNearWin(2, 1.5, 1),
                    new ReelStop(2),

                    new HarlequinNearWin(3, 1.5, 1),
                    new ReelStop(3),

                    //new HarlequinNearWin(4, 0.5, 1),
                    new HarlequinNearWinReelFour(4, 0.7, 0.5),
                    new ReelStop(4),

                    new SpinStop(),

                    new MultiplierBetWins(),

                    new HarlequinSignHandler(),
                ],

                skippable : [
                    [
                        new HarlequinWildNudge(0, 0.2, 0.2),
                        new HarlequinWildNudge(1, 0.2, 0.2),
                        new HarlequinWildNudge(2, 0.2, 0.2),
                        new HarlequinWildNudge(3, 0.2, 0.2),
                        new HarlequinWildNudge(4, 0.2, 0.2)
                    ],
                    [
                        new HarlequinCollectManager()
                    ],
                    [
                        new InitialWin(),
                        new HarlequinBetLineWin(),
                        new NormalWin(GameConfig.instance.WIN_RATIOS.normalWin[3]),
                        new BigWinStart(),
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.normalWin[0], GameConfig.instance.WIN_RATIOS.bigWin[0], undefined, undefined, 1)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[0], GameConfig.instance.WIN_RATIOS.bigWin[1], undefined, undefined, 2)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[1], GameConfig.instance.WIN_RATIOS.bigWin[2], undefined, undefined, 3)
                    ],
                    [
                        new WinEnd(),
                    ]
                ]

            },

            WILD_RESPIN : {
                idle : [
                    new HarlequinBetLineInit(true),
                    new HarlequinWalkerManager(false, true),
                    new HarlequinZeroBet(),
                    //new HarlequinBetlineToggle()
                ],
                idleLoop : [],
                starting : [
                    new MultiplierBetWins(true),
                    new SpinStart(0, 0),

                    new ReelStart(2, 0.05),
                    new ReelStart(1, 0),
                    new ReelStart(3, 0.05),
                    new ReelStart(0, 0),
                    new ReelStart(4, 0.05),

                    new HarlequinWalkerManager(false, false, 0.4, 0.4)
                ],
                stoppable : [
                    // new HarlequinNearWin(0, 2.5, 1),
                    new ReelStop(0),

                    new HarlequinNearWin(1, 1.5, 1),
                    new ReelStop(1),

                    new HarlequinNearWin(2, 1.5, 1),
                    new ReelStop(2),

                    new HarlequinNearWin(3, 1.5, 1),
                    new ReelStop(3),

                    //new HarlequinNearWin(4, 0.5, 1),
                    new HarlequinNearWinReelFour(4, 0.7, 0.5),
                    new ReelStop(4),

                    new SpinStop(),

                    new MultiplierBetWins(),

                    new HarlequinSignHandler()
                ],
                skippable : [
                    [
                        new HarlequinWildNudge(0, 0.2, 0.2),
                        new HarlequinWildNudge(1, 0.2, 0.2),
                        new HarlequinWildNudge(2, 0.2, 0.2),
                        new HarlequinWildNudge(3, 0.2, 0.2),
                        new HarlequinWildNudge(4, 0.2, 0.2),
                    ],
                    [
                        new HarlequinCollectManager()
                    ],
                    [
                        new InitialWin(),
                        new HarlequinBetLineWin(),
                        new NormalWin(GameConfig.instance.WIN_RATIOS.normalWin[3]),
                        new BigWinStart(),
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.normalWin[0], GameConfig.instance.WIN_RATIOS.bigWin[0], undefined, undefined, 1)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[0], GameConfig.instance.WIN_RATIOS.bigWin[1], undefined, undefined, 2)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[1], GameConfig.instance.WIN_RATIOS.bigWin[2], undefined, undefined, 3)
                    ],
                    [
                        new WinEnd(),
                    ]
                ]
            },

            WILD_RESPIN_FS : {
                idle : [
                    new HarlequinBetLineInit(true),
                    new HarlequinWalkerManager(false, true),
                    //new HarlequinInFsCollector(0, false, true),
                    new HarlequinZeroBet()
                ],
                idleLoop : [],
                starting : [
                    new MultiplierBetWins(true),
                    new SpinStart(0, 0),

                    new ReelStart(2, 0.05),
                    new ReelStart(1, 0),
                    new ReelStart(3, 0.05),
                    new ReelStart(0, 0),
                    new ReelStart(4, 0.05),
                    new HarlequinWalkerManager(false, false, 0.4, 0.4),

                ],
                stoppable : [
                    new ReelStop(0),

                    new ReelStop(1),

                    new ReelStop(2),

                    new ReelStop(3),

                    new ReelStop(4),

                    new SpinStop(),

                    new HarlequinSignHandler()
                ],
                skippable : [
                    [
                        new HarlequinWildNudge(0, 0.2, 0.2),
                        new HarlequinWildNudge(1, 0.2, 0.2),
                        new HarlequinWildNudge(2, 0.2, 0.2),
                        new HarlequinWildNudge(3, 0.2, 0.2),
                        new HarlequinWildNudge(4, 0.2, 0.2),
                        new HarlequinAddFreespin(),
                        new WildDrop(4),

                        new InitialWin(),
                        new HarlequinBetLineWin(),
                        new NormalWin(GameConfig.instance.WIN_RATIOS.normalWin[3]),
                        new BigWinStart(),
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.normalWin[0], GameConfig.instance.WIN_RATIOS.bigWin[0], undefined, undefined, 1)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[0], GameConfig.instance.WIN_RATIOS.bigWin[1], undefined, undefined, 2)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[1], GameConfig.instance.WIN_RATIOS.bigWin[2], undefined, undefined, 3)
                    ],
                    [
                        new WinEnd(),
                    ]
                ]
            },

            FREESPIN : {
                idle : [
                    new HarlequinBetLineInit(true),
                    //new HarlequinInFsCollector(0, false, true),
                    new HarlequinZeroBet()
                ],
                idleLoop : [],
                starting : [
                    new MultiplierBetWins(true),
                    new HarlequinScatterCollector(0, false, true), // TODO: check usage
                    new HarlequinWalkerManager(true, true),
                    new SpinStart(),
                    new ReelStart(0, 0),
                    new ReelStart(1, 0),
                    new ReelStart(2, 0),
                    new ReelStart(3, 0),
                    new ReelStart(4, 0),

                    //
                    new HarlequinWalkerManager(false, false, 0.4, 0.4)

                ],
                stoppable : [
                    new WildDropFirstSpin(4),

                    new ReelStop(0),

                    new ReelStop(1),

                    new ReelStop(2),

                    new ReelStop(3),

                    new ReelStop(4),

                    new SpinStop(),

                    new HarlequinSignHandler()
                ],
                skippable : [
                    [
                        new HarlequinWildNudge(0, 0.2, 0.2),
                        new HarlequinWildNudge(1, 0.2, 0.2),
                        new HarlequinWildNudge(2, 0.2, 0.2),
                        new HarlequinWildNudge(3, 0.2, 0.2),
                        new HarlequinWildNudge(4, 0.2, 0.2),
                        new HarlequinAddFreespin(),
                        new WildDrop(4),

                        new InitialWin(),
                        new HarlequinBetLineWin(),
                        new NormalWin(GameConfig.instance.WIN_RATIOS.normalWin[3]),
                        new BigWinStart(),
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.normalWin[0], GameConfig.instance.WIN_RATIOS.bigWin[0], undefined, undefined, 1)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[0], GameConfig.instance.WIN_RATIOS.bigWin[1], undefined, undefined, 2)
                    ],
                    [
                        new BigWinStep(GameConfig.instance.WIN_RATIOS.bigWin[1], GameConfig.instance.WIN_RATIOS.bigWin[2], undefined, undefined, 3)
                    ],
                    [
                        new WinEnd()
                    ]
                ]
            }
        }
    };

    GAME_FEATURE_CREATOR:() => void = () => {
        HarlequinGameModuleConfig.gameTweakerTest = new GameTweakerTest();
        HarlequinGameModuleConfig.countUpView = new CountUpView();
        HarlequinGameModuleConfig.winTextView = new WinTextView();
        HarlequinGameModuleConfig.harlequinWalkerView = new HarlequinWalkerView();
        HarlequinGameModuleConfig.harlequinScatterCollectorView = new HarlequinScatterCollectorView();
        HarlequinGameModuleConfig.harlequinSignView = new HarlequinSignView();
        HarlequinGameModuleConfig.multiplierBetWinView = new MultiplierBetWinView();
        HarlequinGameModuleConfig.nearWinView = new NearWinView();
        HarlequinGameModuleConfig.plusOneView = new HarlequinAddFreespinView();
        HarlequinGameModuleConfig.bonusSplash = new BonusIntroView();

        HarlequinGameModuleConfig.background = new HarlequinBackground({
            layer : HarlequinGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : HarlequinGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                FREESPIN : {image : HarlequinGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                WILD_RESPIN : {image : HarlequinGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                WILD_RESPIN_FS : {image : HarlequinGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)}
            },
            stretch : false
        });

        /*HarlequinGameModuleConfig.reelDivider = new NearWinReelDivider({
            layer : HarlequinGameConfig.instance.LAYERS.REEL_BACKGROUND.name,
            texturesGetter : (index:number) => {return new PIXI.Sprite()},
            positions : [
                [GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y],
                [GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH, GameConfig.instance.REEL_AREA_POS_Y],
                [GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH * 2, GameConfig.instance.REEL_AREA_POS_Y],
                [GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH * 3, GameConfig.instance.REEL_AREA_POS_Y],
                [GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH * 4, GameConfig.instance.REEL_AREA_POS_Y],
                [GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH * 5, GameConfig.instance.REEL_AREA_POS_Y]
            ],
            nearWinLayer : HarlequinGameConfig.instance.LAYERS.REEL_ATTENTION.name,
            nearWinTexturesGetter : (index:number) => {return new PIXI.Sprite()},
            reelIndexMap : [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5]]
        });*/

        HarlequinGameModuleConfig.betLinesView = new HarlequinBetlineView(
            {
                map : [
                    4, 2, 6, 8, 1, 10, 9, 7, 3, 5, // left
                    12, 18, 20, 16, 11, 14, 15, 17, 13, 19 // right
                ]
            },
            (index:number):HarlequinTextBetLineNumber => {
                return new HarlequinTextBetLineNumber(index, {
                    layer : HarlequinGameConfig.instance.LAYERS.BET_LINES.name,
                    width : 40,
                    height : 40,
                    horizontalPadding : GameConfig.instance.REEL_AREA_POS_X - 25,
                    verticalPadding : [
                        GameConfig.instance.REEL_AREA_POS_Y + 40,
                        (GameConfig.instance.GAME_HEIGHT - (GameConfig.instance.REEL_AREA_POS_Y + GameConfig.instance.REEL_AREA_HEIGHT)) + 40
                    ],
                    textStyleNormal : {
                        fontFamily : "Open Sans",
                        fontSize : 20,
                        fill : "#a6759a"
                    },
                    textStyleWin : {
                        fontFamily : "Open Sans",
                        fontSize : 30,
                        fill : "#ffffff",
                        stroke : "#dfb8cd",
                        strokeThickness : 2,
                        padding : 4

                    },
                    textWinScale : 1
                });
            },
            (index:number, numberPosition:number[], betLineData:number[]):PolyBetLine => {
                return new PolyBetLine(index, numberPosition, betLineData, {
                    staticLineLayer : HarlequinGameConfig.instance.LAYERS.BET_LINES.name,
                    styles : [
                        {
                            "lineWidth" : 3,
                            "color" : 0xffffff,
                            "alpha" : 0
                        },
                        {
                            "lineWidth" : 1,
                            "color" : 0xdfb8cd,
                            "alpha" : 0
                        }
                    ],
                    numberOffsetX : 20,
                    pointOverlapVerticalOffset : 8
                });
            }
        );

        StageManager.legacyScaling = false;

        HarlequinGameModuleConfig.featurePrice = new FeaturePrice();
    };

    public static countUpView:CountUpView;
    public static winTextView:WinTextView;
    public static harlequinWalkerView:HarlequinWalkerView;
    public static harlequinScatterCollectorView:HarlequinScatterCollectorView;
    public static harlequinSignView:HarlequinSignView;
    public static multiplierBetWinView:MultiplierBetWinView;
    public static betLinesView:HarlequinBetlineView;
    public static nearWinView:NearWinView;
    public static plusOneView:HarlequinAddFreespinView;
    public static bonusSplash:BonusIntroView;

    private static _CURRENT_MODE:string = "NORMAL";
    public static get CURRENT_MODE():string {
        return HarlequinGameModuleConfig._CURRENT_MODE;
    }

    public static set CURRENT_MODE(mode:string) {
        HarlequinGameModuleConfig._CURRENT_MODE = mode;
    }

    constructor() {
        if(HarlequinGameModuleConfig.instance) {
            throw new Error("HarlequinGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}